var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showAsTotal && _vm.showModifier)?_c('span',{class:_vm.siteIdentityClass('option-cost__modifier')},[_vm._v("+")]):_vm._e(),_vm._v(" "),_c('span',{class:_vm.siteIdentityClass('option-cost__lead-in-string')},[_vm._v(_vm._s(_vm.costString))]),_vm._v(" "),(_vm.isPerFrame)?_c('span',{staticClass:"visible-lg-inline"},[_vm._v(" / @BrandInvariant.Image.ToLower()")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6177ed6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/shared/components/catalog/PackageOption/OptionCost.vue
// module id = 797
// module chunks = 0 2